<template>
    <div style="background: #0B0B19" class="d-flex align-items-center justify-content-center h-100" >
        <h4 class="waiting-title text-white"> <i class="fa fa-circle-o-notch fa-spin mr-2"></i> {{$t('_please_wait')}}
        </h4>
    </div>
</template>

<script>
    export default {
        name: "InitializeApp",
    }
</script>

<style scoped lang="scss">
    .loader-container {
        display: flex;
    }
</style>